/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Invalid_TimecodeInputs */



/**
* | output |
* | --- |
* | "Invalid timecode" |
*
* @param {Editor_Table_Invalid_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_invalid_timecode = /** @type {((inputs?: Editor_Table_Invalid_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Invalid_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code temporel invalide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiger Zeitcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale non valido")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неверный временной код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo no válido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无效时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無効なタイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अमान्य टाइमकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo inválido")
	return /** @type {LocalizedString} */ ("Invalid timecode")
});